import { Link } from "react-router-dom";
import Container from "@/components/Container/Container";
import Section from "@/components/Section/Section";
import PageHero from "@/components/PageHero/PageHero";
import CTASection from "@/components/CTASection/CTASection";
import styles from "./ModalitiesPage.module.css";

const modalities = [
  {
    eyebrow: "Brainspotting",
    title: "A brain-body therapy for processing trauma and emotional pain.",
    body: "Brainspotting helps access and process trauma, emotional pain, and deeply held experiences that may not be easily reached through traditional talk therapy. The premise: where you look affects how you feel.",
    bullets: [
      "Trauma and PTSD",
      "Anxiety and chronic stress",
      "Performance blocks",
      "Emotional overwhelm",
      "Processing difficult life events",
    ],
    link: { to: "/modalities/brainspotting", label: "Learn more about Brainspotting" },
  },
  {
    eyebrow: "Somatic therapy",
    title: "Working with the connection between mind and body.",
    body: "When we experience stress or trauma, our nervous system can become stuck in patterns of fight, flight, freeze, or shutdown. Somatic therapy helps you work with the body—not just the mind—for deeper, more stable relief.",
    bullets: [
      "Increase awareness of bodily sensations",
      "Release stored tension and stress",
      "Build nervous system regulation",
      "Develop greater emotional resilience",
    ],
  },
  {
    eyebrow: "Systems therapy",
    title: "Understanding the relationships and patterns that shape us.",
    body: "As a Marriage and Family Therapist, my work is deeply informed by systems theory, which recognizes that individuals are shaped by the relationships and environments around them.",
    bullets: [
      "Family relationships",
      "Couples dynamics",
      "Communication styles",
      "Intergenerational influences",
    ],
  },
  {
    eyebrow: "Solution-focused therapy",
    title: "Building on the strengths and resources already within you.",
    body: "Rather than focusing only on problems, solution-focused therapy emphasizes strengths, resilience, and the possibilities for change that already exist.",
    bullets: [
      "What is already working",
      "Small, meaningful steps toward change",
      "Existing strengths and resources",
      "Clear and achievable goals",
    ],
  },
  {
    eyebrow: "Ketamine-Assisted Psychotherapy (KAP)",
    title: "Combining ketamine with guided psychotherapy for deeper processing.",
    body: "KAP combines the therapeutic benefits of ketamine with guided psychotherapy to support deeper emotional processing and healing. Sessions focus on preparation, therapeutic support during the experience, and integration afterward.",
    bullets: ["Depression", "Trauma", "Anxiety", "Treatment-resistant symptoms"],
  },
];

export default function ModalitiesPage() {
  return (
    <>
      <PageHero
        eyebrow="Therapeutic modalities"
        title="An integrative approach woven from several traditions."
        intro="My work combines brain-based, somatic, relational, and solution-focused approaches—so therapy can address both the emotional and physiological aspects of healing."
        accent="bloom"
      />

      <Section spacing="loose">
        <Container width="default">
          <div className={styles.grid}>
            {modalities.map((m) => (
              <article key={m.eyebrow} className={styles.card}>
                <span className="eyebrow">{m.eyebrow}</span>
                <h2 className={styles.title}>{m.title}</h2>
                <p className={styles.body}>{m.body}</p>
                <ul className={styles.bullets}>
                  {m.bullets.map((b) => (
                    <li key={b}>{b}</li>
                  ))}
                </ul>
                {m.link ? (
                  <Link to={m.link.to} className={styles.cardLink}>
                    {m.link.label} &nbsp;→
                  </Link>
                ) : null}
              </article>
            ))}
          </div>
        </Container>
      </Section>

      <CTASection />
    </>
  );
}
